import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const email = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '邮件编号',
            dataIndex: 'mailSign',
            key: 'mailSign',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.mailSign || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同编号',
            dataIndex: 'contractNo',
            key: 'contractNo',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.contractNo || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '收件邮箱',
            dataIndex: 'toMails',
            key: 'toMails',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender:'toMails'
            },
            filteredValue: filteredInfo.toMails || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '抄送邮箱',
            dataIndex: 'ccMails',
            key: 'ccMails',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'ccMails'
            },
            filteredValue: filteredInfo.ccMails || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '邮件类型',
            dataIndex: 'mailType',
            key: 'mailType',
            scopedSlots: {
                filterDropdown: 'filterMailType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'mailType'
            },
            filteredValue: filteredInfo.mailType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发送时间',
            dataIndex: 'sendTime',
            key: 'sendTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发送状态',
            dataIndex: 'mailStatus',
            key: 'mailStatus',
            scopedSlots: {
                filterDropdown: 'filterMailStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'mailStatus'
            },
            filteredValue: filteredInfo.mailStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        }
    ]
}
